import { TInsuranceCondition } from '../api';

export const USER_GOLD_ASSET_CACHE_KEY = 'investment-gold-user-asset';

export type TGoldTradingAction = 'buy' | 'sell';
export type TGoldTradingRestrictionVariant = 'warning' | 'danger';

export type TRestrictionContent = {
  title: string;
  description: string;
  variant: TGoldTradingRestrictionVariant;
};

export type TUseGoldTradingRestrictionParams = {
  condition?: TInsuranceCondition;
  action: TGoldTradingAction;
};
